import GlyphIcon from "./GlyphIcon.mjs";

const ReplyIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M6.11658,15.94891l5.87268,4.195v1.31366A1,1,0,0,1,10.408,22.271L1.32977,15.78613a1,1,0,0,1,0-1.62744L10.408,7.67432a1.00008,1.00008,0,0,1,1.58124.814v1.313L6.11658,13.99591A1.2,1.2,0,0,0,6.11658,15.94891Zm25.78149,5.41242a15.7601,15.7601,0,0,0-11.90881-9.72266V8.72852a1.12371,1.12371,0,0,0-1.7768-.91456L9.47058,14.05811a1.12351,1.12351,0,0,0,0,1.82861l8.74188,6.24463a1.12371,1.12371,0,0,0,1.7768-.91455V18.002a13.80114,13.80114,0,0,1,9.74261,4.59961,1.01106,1.01106,0,0,0,1.204.24024l.47077-.23633A1.01248,1.01248,0,0,0,31.89807,21.36133Z"
				{...this.props}
			/>
		);
	}
}

export default ReplyIcon;